export class ReloadUserDataAction {
  static type = '[AUTH] Reload user data';
}
